import { create } from 'zustand'
import { DiscountModalStore } from './types'

const TWENTY_FOUR_HOURS = 1000 * 60 * 60 * 24
const THIRTY_DAYS = 1000 * 60 * 60 * 24 * 30

const hasExpired24Hours = (timestamp: number) =>
  Date.now() - timestamp > TWENTY_FOUR_HOURS

const hasExpired30Days = (timestamp: number) =>
  Date.now() - timestamp > THIRTY_DAYS

const getStoredTimestamp = (key: string) => {
  if (typeof window === 'undefined') return null
  const stored = localStorage.getItem(key)
  if (!stored) return null
  const timestamp = parseInt(stored)
  return isNaN(timestamp) ? null : timestamp
}

export const discountModalStore = create<DiscountModalStore>((set) => {
  const SIGNUP_KEY = 'discount_modal_closed_at'
  const AUTO_POPUP_KEY = 'discount_modal_auto_popup_dismissed_at'

  const signupTimestamp = getStoredTimestamp(SIGNUP_KEY)
  const autoPopupTimestamp = getStoredTimestamp(AUTO_POPUP_KEY)

  return {
    isOpen: false,
    autoPopupDismissed:
      autoPopupTimestamp !== null && !hasExpired24Hours(autoPopupTimestamp),
    hasSignedUp: signupTimestamp !== null && !hasExpired30Days(signupTimestamp),

    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),

    dismissAutoPopup: () => {
      if (typeof window !== 'undefined') {
        localStorage.setItem(AUTO_POPUP_KEY, Date.now().toString())
      }
      set({ autoPopupDismissed: true })
    },

    checkSignupStatus: () => {
      const signupTimestamp = getStoredTimestamp(SIGNUP_KEY)
      if (signupTimestamp && !hasExpired30Days(signupTimestamp)) {
        set({ hasSignedUp: true })
      } else {
        set({ hasSignedUp: false })
      }

      const autoPopupTimestamp = getStoredTimestamp(AUTO_POPUP_KEY)
      if (autoPopupTimestamp && !hasExpired24Hours(autoPopupTimestamp)) {
        set({ autoPopupDismissed: true })
      } else {
        set({ autoPopupDismissed: false })
      }
    },
  }
})

export const useDiscountModalStore = discountModalStore
